
@if (this._httpLoadingService.loading$ | async) {
  <div class="spinner-container">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">{{'Common.Loading' | translate}}</span>
    </div>
  </div>
}
